type LineItem = {
  name: string;
  unitAmount: string;
}

interface ModifyCreateOrderPayloadProps {
  amount: string;
  lineItems: LineItem[];
  shippingOptions?: any[];
}

export function modifyCreateOrderPayload(payPalPaymentRequest: ModifyCreateOrderPayloadProps) {
  // If delivery address and charge are already set via checkout, modify the original createOrder payload
  // to remove shippingOptions, delivery charge lineItem, and modify amount to remove delivery charge
  // otherwise paypal express will show customer an error

  const index = payPalPaymentRequest?.lineItems?.findIndex((lineItem: LineItem) => lineItem?.name === 'Delivery charge');
  if (index < 0) return payPalPaymentRequest;

  const deliveryChargeLineItem = payPalPaymentRequest.lineItems.splice(index, 1)[0];
  const newAmount = Number(payPalPaymentRequest?.amount) - Number(deliveryChargeLineItem?.unitAmount);
  const { shippingOptions: _, ...rest } = payPalPaymentRequest;

  return ({
    ...rest,
    amount: newAmount.toString(),
  });
}
